
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { SecMagasin } from "../../../models/SecMagasin";
import { useGetSecMagasinsQuery } from "../../../redux/features/cache";
import { useAppSelector } from "../../../redux/store";
import { getModalStyle } from "../../modalStyle";
import { MagasinForm } from "../../section2/component/MagasinForm";
import GenericModal from "../modals/GenericModal";
import FormMagasin from "./Forms/FormMagasin";

interface IWrapperMagasin {
    sec: number
    mag: string
    plans_nom: string
}

export default function WrapperMagasin({ sec, mag, plans_nom }: IWrapperMagasin) {
    const { data: secMagasins = [] as SecMagasin[] } = useGetSecMagasinsQuery({ sec, mag });
    const [open, setOpen] = useState<boolean>(false);
    const prod_plano = useAppSelector((state) => state.appState.prod_plano);
    return (
        <>
            <GenericModal
                open={open}
                handleClose={() => setOpen(false)}
                style={getModalStyle}
                title="Ajouter un nouveau magasin">
                <MagasinForm plansSeq={sec} setOpen={setOpen} canDelete={prod_plano.canDelete} />
            </GenericModal>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, minWidth: '35vw' }}>
                <Typography variant="h5" sx={{ color: '#007bff' }} >{plans_nom}</Typography>

                <Button variant='contained' onClick={() => setOpen(true)} sx={{ width: '300px', borderRadius: '30px', backgroundColor: '#007bff', color: 'white' }} disabled={!prod_plano.canAdd}>Ajouter un magasin</Button>
            </Box>
            {secMagasins &&
                secMagasins.map((e, i) => (
                    <FormMagasin data={e} key={e.mag_num} />
                ))}

        </>
    );
}

